import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/base'
import './plugins/vue-cookies'
// import './plugins/vue-froala-wysiwyg'
import './plugins/vue-application-insights'
// import './plugins/vue-world-map' //Maybe use in future
import './shared/custom-filters'
// import { userInfo } from 'os'
// import VueI18n from './i18n';
import './plugins/script-loader'

Vue.config.productionTip = false
Vue.config.silent = false
Vue.use(require('vue-moment'))

Vue.mixin({
  methods: {
    $_global_parseAsUtc (utc) {
      if (!utc || utc === undefined || utc === null) return null
      let _utc = utc.endsWith('Z') ? utc : `${utc}Z`
      return new Date(_utc)
    }
  }
})

new Vue({
  router,
  vuetify,
  // i18n: VueI18n,
  render: h => h(App)
}).$mount('#app')
